import type { HeicConverter } from "./index.js";

/**
 * HEIC → JPEG in the browser, through `heic2any`, which is fetched only when
 * a HEIC file arrives (dynamic import). HEIC is never stored. `load` is the
 * test seam.
 */
type Heic2Any = (opts: { blob: Blob; toType?: string; quality?: number }) => Promise<Blob | Blob[]>;

export function createHeicConverter(
  load: () => Promise<{ default: Heic2Any }> = () => import("heic2any") as Promise<{ default: Heic2Any }>,
): HeicConverter {
  return async (file) => {
    const { default: heic2any } = await load();
    const out = await heic2any({ blob: file, toType: "image/jpeg", quality: 0.9 });
    const blob = Array.isArray(out) ? out[0] : out;
    if (!blob) throw new Error("HEIC conversion produced no image");
    const name = /\.(heic|heif)$/i.test(file.name) ? file.name.replace(/\.(heic|heif)$/i, ".jpg") : `${file.name}.jpg`;
    return new File([blob], name, { type: "image/jpeg", lastModified: file.lastModified });
  };
}
